//src/services/adminShippingSettings.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminShippingSettings = () =>
  adminApiRequest("/shipping-settings/admin");

export const saveAdminShippingSettings = (data) =>
  adminApiRequest("/shipping-settings/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });